import React, { useState, useEffect } from 'react';
import { StyleSheet } from 'react-native';

interface VoidOrderReasonPopupProps {
    onClose: () => void;
    onReasonSelected: (reason: string) => void;
}


const VoidOrderReasonPopup: React.FC<VoidOrderReasonPopupProps> = ({ onClose, onReasonSelected }) => {
    const [reason, setReason] = useState('');
    const handleSubmit = () => {
        console.log(reason)
        if(reason != ''){
            onReasonSelected(reason);
        }
    };

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const styles = StyleSheet.create({
        popup: {
            width: windowSize.width > 900 ? windowSize.width * 0.40 : windowSize.width * 0.9,
            backgroundColor: '#fff',
            position: 'fixed',
            zIndex: 8000,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        },
        input: {
            shadowOpacity: 0,
            borderRadius: 8,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: '#D0D5DD',
            height: 35
        }
    });

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const value = e.target.value;
        if (value.length <= 160) {
            setReason(value);
        }
    };

    return (
        <div style={styles.popup} className='popup-shadow ds-pop ds-pop--center'>
            <div className='d-flex px-3 pt-3 justify-content-end'>
                <button className='text-btn p-0 m-0 d-flex justify-content-center' onClick={onClose}>
                    <svg width="10" height="10" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 1L1 13M1 1L13 13" stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
            <div className='d-flex px-3 pt-3 justify-content-between'>
                <h5>Void Order</h5>
            </div>
            <div className='px-3 pb-3 d-flex flex-column'>
                <small className='mt-2 mb-3'>
                    Enter a reason for voiding the order.
                </small>
                <textarea
                    rows={4}
                    value={reason}
                    onChange={handleChange}
                    placeholder="Enter your reason"
                />
            </div>
            <div className='d-flex mt-4 p-2 align-items-center justify-content-end' style={{ gap: '10px', flexWrap: 'nowrap', backgroundColor: '#F3F4F6' }}>
                <button className='blue-outline-btn align-items-center d-flex' onClick={onClose} style={{ borderRadius: 8 }}>
                    Cancel
                </button>
                <button className='blue-filled-btn align-items-center d-flex' onClick={handleSubmit} style={{ borderRadius: 8 }}>
                    Submit
                </button>
            </div>
        </div>
    );
};

export default VoidOrderReasonPopup;

